import React, { useMemo, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Button from "../../components/ui/Button";
import Field from "../../components/ui/Field";
import Input from "../../components/ui/Input";
import { resetPasswordRequest } from "../../services/api/auth.api";

const ResetPasswordPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const token = useMemo(() => searchParams.get("token") ?? "", [searchParams]);

    const [newPassword, setNewPassword] = useState("");
    const [globalError, setGlobalError] = useState<string | null>(null);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setGlobalError(null);
        setSuccessMessage(null);
        setIsSubmitting(true);

        try {
            await resetPasswordRequest({
                token,
                new_password: newPassword,
            });

            setSuccessMessage("Пароль успешно изменён. Сейчас произойдёт переход на страницу входа.");

            window.setTimeout(() => {
                navigate("/login");
            }, 1500);
        } catch (error) {
            const message =
                error instanceof Error ? error.message : "Не удалось изменить пароль";
            setGlobalError(message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="auth-layout">
            <div className="auth-panel">
                <div className="auth-panel-head">
                    <div className="auth-logo">S</div>
                    <p className="auth-kicker">ShowMust Admin</p>
                    <h1 className="auth-title">Установка нового пароля</h1>
                    <p className="auth-description">
                        Страница принимает token из query-параметра и отправляет новый пароль в API.
                    </p>
                </div>

                <form className="auth-form" onSubmit={handleSubmit}>
                    <Field label="Новый пароль" htmlFor="newPassword">
                        <Input
                            id="newPassword"
                            type="password"
                            placeholder="Введите новый пароль"
                            autoComplete="new-password"
                            value={newPassword}
                            onChange={(event) => setNewPassword(event.target.value)}
                        />
                    </Field>

                    {globalError ? <div className="form-global-error">{globalError}</div> : null}
                    {successMessage ? <div className="form-global-success">{successMessage}</div> : null}

                    <Button type="submit" fullWidth disabled={isSubmitting || !token}>
                        {isSubmitting ? "Сохраняем..." : "Сохранить пароль"}
                    </Button>
                </form>

                <div className="auth-links">
                    <Link to="/login" className="text-link">
                        Вернуться ко входу
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
